var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTotalTransactionCount(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.5,
    height: 23.5,
    viewBox: "0 0 23.5 23.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Total_Transaction_Count",
    "data-name": "Total Transaction Count",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18359",
    "data-name": "Path 18359",
    d: "M11,0A11,11,0,1,1,0,11,11,11,0,0,1,11,0Z",
    transform: "translate(0.5 0.5)",
    fill: "none",
    stroke: "#517ce3",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18363",
    "data-name": "Path 18363",
    d: "M12.524,4.415a.562.562,0,0,1,.794,0l3.37,3.37a.562.562,0,0,1,.164.4,2.649,2.649,0,0,1-.164.562H6.181a.562.562,0,1,1,0-1.123h8.754L12.524,5.209a.562.562,0,0,1,0-.794ZM4.167,10.359h8.754a.562.562,0,0,1,0,1.123H4.167l2.411,2.411a.562.562,0,1,1-.794.794l-3.37-3.37a.562.562,0,0,1-.164-.4,2.649,2.649,0,0,1,.164-.562Z",
    transform: "translate(1.949 1.941)",
    fill: "#517ce3",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalTransactionCount);
export default __webpack_public_path__ + "static/media/Total_Transaction_Count.4d80012cd1d642639686a168f2555e18.svg";
export { ForwardRef as ReactComponent };